import { useState } from "react";
import { useDispatch } from "react-redux";
import { requestWithdrawal } from "../redux/WithdralSlice/withdrawalSlice";

const WithdrawalForm = ({ userId }) => {
  const [amount, setAmount] = useState("");
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (amount < 100) {
      alert("Minimum withdrawal amount is 100");
      return;
    }
    dispatch(requestWithdrawal({ userId, amount: parseFloat(amount) }));
    setAmount("");
  };

  return (
    <div className="p-4 bg-white shadow-lg rounded-md">
      <h2 className="text-lg font-semibold mb-2">Request Withdrawal</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="Enter amount"
          className="w-full p-2 border rounded-md mb-2"
          required
        />
        <button className="bg-blue-500 text-white px-4 py-2 rounded-md">
          Request
        </button>
      </form>
    </div>
  );
};

export default WithdrawalForm;
